export default __webpack_public_path__ + "static/media/turn-sharp-left.b6dd82ae.svg";